var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generic-slider--container"},[_c('div',{staticClass:"generic-slider--header_wrapper"},[_c('h5',[_vm._v(_vm._s(_vm.$t(_vm.title)))])]),(_vm.items.length)?_c('slider-content',{attrs:{"isLoading":_vm.isLoading,"selectedTab":0,"tabItems":[_vm.items],"type":_vm.type},on:{"emitSliderContent":_vm.emitFunction}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }